import { BreadCrumbItem } from "../BreadCrumbs";
import { type Template } from "@zapier/templates";

type TemplateLibraryType = "Interfaces" | "Tables" | "Chatbot";

export const getBreadcrumbs = (template: Template): BreadCrumbItem[] => {
  let templateType: TemplateLibraryType = "Interfaces";
  if (
    template.products?.items.some((p) => p.slug === "tables") &&
    !template.products?.items.some((p) => p.slug === "interfaces")
  )
    templateType = "Tables";

  if (
    (template.products?.items.some((p) => p.slug === "chatbot") &&
      !template.products?.items.some((p) => p.slug === "interfaces")) ||
    template.primaryProduct === "chatbot"
  )
    templateType = "Chatbot";

  return [
    { text: "Templates", href: "/templates" },
    {
      text: templateType,
      href: `/templates/${templateType.toLowerCase()}`,
    },
    { text: template.name },
  ];
};
